import useAuth from "../../../Redux/useAuth";
import { AvatarPreview } from "./AvatarUserViewStyles.styled";

interface AvatarUserViewProps {
  onClick?: () => void;
  newAvatarUser?: string;
}

export const AvatarUserView: React.FC<AvatarUserViewProps> = ({newAvatarUser, onClick }) => {
  const { user } = useAuth();
  return (
    <>
      <AvatarPreview
        crossOrigin='anonymous'
        src={newAvatarUser}
        alt={`${user?.name}'s avatar`}
        onClick={onClick}
      />
    </>
  );
};
